// YouTube (pages, table, previews, forms) i18n fragment — part 1
// Namespaces file-scoped: yt.scheduledShares.*, yt.videos.*, yt.youtubeAccount.*,
// yt.table.*, yt.videoShareHistory.*, yt.youtubeAccountForm.*, yt.youtubeLoginGuide.*,
// yt.facebookPostPreview.*, yt.xPostPreview.*
// vi = verbatim Vietnamese, en = natural concise English. Keys stay in parity.
const fragment = {
  vi: {
    // ScheduledShares.js — status filters
    'yt.scheduledShares.status.all': 'Tất cả',
    'yt.scheduledShares.status.pending': 'Chờ chạy',
    'yt.scheduledShares.status.processing': 'Đang chạy',
    'yt.scheduledShares.status.done': 'Hoàn tất',
    'yt.scheduledShares.status.failed': 'Thất bại',
    'yt.scheduledShares.status.canceled': 'Đã hủy',
    // ScheduledShares.js — relative time
    'yt.scheduledShares.rel.soon': 'sắp đến',
    'yt.scheduledShares.rel.justNow': 'vừa xong',
    'yt.scheduledShares.rel.inMinutes': 'còn {n} phút',
    'yt.scheduledShares.rel.minutesAgo': '{n} phút trước',
    'yt.scheduledShares.rel.inHours': 'còn {n} giờ',
    'yt.scheduledShares.rel.hoursAgo': '{n} giờ trước',
    'yt.scheduledShares.rel.inDays': 'còn {n} ngày',
    'yt.scheduledShares.rel.daysAgo': '{n} ngày trước',
    // ScheduledShares.js — edit batch drawer
    'yt.scheduledShares.drawer.shiftLater': 'trễ hơn',
    'yt.scheduledShares.drawer.shiftEarlier': 'sớm hơn',
    'yt.scheduledShares.drawer.amountMinutes': '{n} phút',
    'yt.scheduledShares.drawer.amountHours': '{n} giờ',
    'yt.scheduledShares.drawer.shiftSummary': '→ Dịch {amount} {direction}',
    'yt.scheduledShares.drawer.noChange': 'Không có thay đổi nào.',
    'yt.scheduledShares.drawer.captionOverLimit': 'Caption vượt giới hạn ký tự.',
    'yt.scheduledShares.drawer.selectAtLeastOnePage': 'Chọn ít nhất 1 page.',
    'yt.scheduledShares.drawer.startMustBeFuture': 'Thời gian bắt đầu mới phải trong tương lai.',
    'yt.scheduledShares.drawer.pagesGone':
      'Page đã chọn không còn trong tài khoản. Vui lòng chọn lại.',
    'yt.scheduledShares.drawer.title': 'Sửa lịch tổng — toàn bộ pending của kênh',
    'yt.scheduledShares.drawer.pendingWillUpdate':
      '{n} bài pending sẽ được cập nhật (xuyên tất cả batch)',
    'yt.scheduledShares.drawer.pendingNote':
      'Bài đã đăng / đang chạy / đã huỷ giữ nguyên — không ảnh hưởng. Chỉ gửi field bạn thực sự đổi.',
    'yt.scheduledShares.drawer.sectionPages': 'Pages đích',
    'yt.scheduledShares.drawer.changed': 'Đã đổi',
    'yt.scheduledShares.drawer.reload': 'Tải lại',
    'yt.scheduledShares.drawer.searchPagePlaceholder': 'Tìm theo tên page...',
    'yt.scheduledShares.drawer.loadPagesFailed': 'Không tải được pages.',
    'yt.scheduledShares.drawer.noPages': 'Tài khoản Facebook chưa quản lý page nào.',
    'yt.scheduledShares.drawer.noPageMatch': 'Không tìm thấy page khớp "{q}".',
    'yt.scheduledShares.drawer.unselect': 'Bỏ chọn',
    'yt.scheduledShares.drawer.selectVisible': 'Chọn {n} page hiển thị',
    'yt.scheduledShares.drawer.selectAll': 'Chọn tất cả {n} page',
    'yt.scheduledShares.drawer.sectionCaption': 'Caption template',
    'yt.scheduledShares.drawer.tokenLabel': 'Token',
    'yt.scheduledShares.drawer.tokenSuffix': 'render per video',
    'yt.scheduledShares.drawer.charCount': '{n} / {max} ký tự',
    'yt.scheduledShares.drawer.sectionStart': 'Thời gian bắt đầu',
    'yt.scheduledShares.drawer.startHintPrefix': 'Đổi giờ bài ',
    'yt.scheduledShares.drawer.startHintBold': 'đầu tiên',
    'yt.scheduledShares.drawer.startHintSuffix':
      ' — tất cả bài còn lại sẽ dịch theo cùng delta, giữ nguyên khoảng cách giữa các video.',
    'yt.scheduledShares.drawer.pickNewStart': 'Chọn ngày giờ bắt đầu mới',
    'yt.scheduledShares.drawer.currentFirst': 'Bài đầu hiện tại: {time}',
    'yt.scheduledShares.drawer.currentLast': ' → bài cuối: {time}',
    'yt.scheduledShares.drawer.willChange': 'Sẽ đổi:',
    'yt.scheduledShares.drawer.badgePages': 'Pages',
    'yt.scheduledShares.drawer.badgeCaption': 'Caption',
    'yt.scheduledShares.drawer.badgeTime': 'Thời gian',
    'yt.scheduledShares.drawer.noChangesYet': 'Chưa có thay đổi nào.',
    'yt.scheduledShares.drawer.cancel': 'Huỷ',
    'yt.scheduledShares.drawer.save': 'Lưu',
    'yt.scheduledShares.drawer.saveWithCount': 'Lưu ({n} bài)',
    // ScheduledShares.js — main view
    'yt.scheduledShares.channelUntitled': 'Kênh chưa đặt tên',
    'yt.scheduledShares.allChannels': 'Tất cả kênh',
    'yt.scheduledShares.editItem.invalidTime': 'Vui lòng chọn thời gian hợp lệ.',
    'yt.scheduledShares.editItem.mustBeFuture': 'Thời gian phải trong tương lai.',
    'yt.scheduledShares.editItem.updated': 'Đã cập nhật bài lên lịch.',
    'yt.scheduledShares.editItem.updateFailed': 'Cập nhật thất bại.',
    'yt.scheduledShares.item.resumed': 'Đã tiếp tục chạy bài này.',
    'yt.scheduledShares.item.paused': 'Đã tạm dừng bài này.',
    'yt.scheduledShares.item.resumeFailed': 'Tiếp tục thất bại.',
    'yt.scheduledShares.item.pauseFailed': 'Tạm dừng thất bại.',
    'yt.scheduledShares.editAll.selectChannelFirst': 'Vui lòng chọn 1 kênh YouTube trước khi sửa.',
    'yt.scheduledShares.editAll.fieldPages': 'pages',
    'yt.scheduledShares.editAll.fieldCaption': 'caption',
    'yt.scheduledShares.editAll.fieldTime': 'thời gian',
    'yt.scheduledShares.editAll.updatedSkipped':
      'Đã cập nhật {fields} cho {updated} bài. Bỏ qua {skipped}.',
    'yt.scheduledShares.editAll.updated': 'Đã cập nhật {fields} cho {updated} bài.',
    'yt.scheduledShares.editAll.updateFailed': 'Cập nhật thất bại.',
    'yt.scheduledShares.pause.selectChannelFirst':
      'Vui lòng chọn 1 kênh YouTube trước khi tạm dừng.',
    'yt.scheduledShares.pause.noActive': 'Không còn bài đang chạy để tạm dừng.',
    'yt.scheduledShares.pause.confirmTitle': 'Tạm dừng lịch của kênh?',
    'yt.scheduledShares.pause.confirmDesc':
      'Tất cả {n} bài đang chờ chạy sẽ bị tạm dừng — cron không tự đăng cho đến khi bạn bấm "Tiếp tục chạy". Bài đã đăng / đang chạy không bị ảnh hưởng.',
    'yt.scheduledShares.pause.confirmText': 'Tạm dừng',
    'yt.scheduledShares.pause.success': 'Đã tạm dừng {n} bài.',
    'yt.scheduledShares.pause.failed': 'Tạm dừng thất bại.',
    'yt.scheduledShares.resume.selectChannelFirst':
      'Vui lòng chọn 1 kênh YouTube trước khi tiếp tục.',
    'yt.scheduledShares.resume.noPaused': 'Không có bài nào đang tạm dừng.',
    'yt.scheduledShares.resume.success':
      'Đã tiếp tục {n} bài. Bài quá giờ sẽ chạy ở tick cron kế tiếp.',
    'yt.scheduledShares.resume.failed': 'Tiếp tục thất bại.',
    'yt.scheduledShares.cancelAll.selectChannelFirst':
      'Vui lòng chọn 1 kênh YouTube trước khi huỷ.',
    'yt.scheduledShares.cancelAll.noPending': 'Kênh này không còn bài pending để huỷ.',
    'yt.scheduledShares.cancelAll.confirmTitle': 'Huỷ {n} bài pending?',
    'yt.scheduledShares.cancelAll.confirmDesc':
      'Tất cả {n} bài đang chờ chạy của kênh sẽ chuyển sang trạng thái "Đã huỷ" và không tự động đăng nữa. Bài đã đăng / đang chạy giữ nguyên. Thao tác không thể hoàn tác.',
    'yt.scheduledShares.cancelAll.confirmText': 'Huỷ tất cả',
    'yt.scheduledShares.cancelAll.success': 'Đã huỷ {n} bài pending.',
    'yt.scheduledShares.cancelAll.failed': 'Huỷ thất bại.',
    'yt.scheduledShares.cancel.confirmTitle': 'Hủy lịch share?',
    'yt.scheduledShares.cancel.confirmDesc': 'Bài đăng "{title}" sẽ không được chia sẻ.',
    'yt.scheduledShares.cancel.confirmText': 'Hủy lịch',
    'yt.scheduledShares.cancel.success': 'Đã hủy lịch.',
    'yt.scheduledShares.cancel.failed': 'Hủy thất bại.',
    'yt.scheduledShares.runNow.confirmTitle': 'Chạy ngay?',
    'yt.scheduledShares.runNow.confirmDesc': 'Bài đăng sẽ được chia sẻ trong vài giây tới.',
    'yt.scheduledShares.runNow.confirmText': 'Chạy ngay',
    'yt.scheduledShares.runNow.triggered': 'Đã trigger. Trạng thái cập nhật sau vài giây.',
    'yt.scheduledShares.runNow.failed': 'Trigger thất bại.',
    'yt.scheduledShares.back': 'Quay lại',
    'yt.scheduledShares.heading': 'Lịch chia sẻ YouTube',
    'yt.scheduledShares.subtitle':
      'Quản lý các bài đăng được lên lịch tự động chia sẻ tới Facebook Page',
    'yt.scheduledShares.editAllTip.selectChannel': 'Chọn 1 kênh YouTube để sửa lịch tổng',
    'yt.scheduledShares.editAllTip.noPending': 'Kênh này không còn bài pending để sửa',
    'yt.scheduledShares.editAllTip.has':
      'Sửa pages / caption / thời gian cho {n} bài pending của kênh này',
    'yt.scheduledShares.editAllBtn': 'Sửa lịch tổng',
    'yt.scheduledShares.cancelAllTip.selectChannel': 'Chọn 1 kênh YouTube để huỷ pending',
    'yt.scheduledShares.cancelAllTip.noPending': 'Kênh này không còn bài pending',
    'yt.scheduledShares.cancelAllTip.has': 'Huỷ tất cả {n} bài pending của kênh này',
    'yt.scheduledShares.cancelAllBtn': 'Huỷ tổng',
    'yt.scheduledShares.pauseTip.selectChannel': 'Chọn 1 kênh YouTube trước',
    'yt.scheduledShares.pauseTip.resume': 'Tiếp tục chạy {n} bài đang tạm dừng',
    'yt.scheduledShares.pauseTip.noActive': 'Không còn bài nào đang chạy để tạm dừng',
    'yt.scheduledShares.pauseTip.pause':
      'Tạm dừng {n} bài đang chờ — cron sẽ skip cho đến khi bạn tiếp tục',
    'yt.scheduledShares.resumeBtn': 'Tiếp tục chạy',
    'yt.scheduledShares.pauseBtn': 'Tạm dừng lịch',
    'yt.scheduledShares.reload': 'Tải lại',
    'yt.scheduledShares.toChannels': 'Tới kênh YouTube',
    'yt.scheduledShares.channelLabel': 'Kênh:',
    'yt.scheduledShares.empty.statusTitle': 'Không có lịch ở trạng thái "{status}"',
    'yt.scheduledShares.empty.title': 'Chưa có lịch chia sẻ nào',
    'yt.scheduledShares.empty.descPrefix':
      'Tạo lịch để tự động chia sẻ video YouTube lên Facebook Page vào thời gian bạn chọn. Vào danh sách video của 1 kênh → tick chọn nhiều video → nhấn ',
    'yt.scheduledShares.empty.descBold': 'Lên lịch share',
    'yt.scheduledShares.empty.descSuffix': '.',
    'yt.scheduledShares.empty.cta': 'Đi tới danh sách kênh',
    'yt.scheduledShares.item.noTitle': '(không có tiêu đề)',
    'yt.scheduledShares.item.pausedBadge': 'Tạm dừng',
    'yt.scheduledShares.item.pageCount': '{n} page',
    'yt.scheduledShares.item.runNowDisabledTip':
      'Đang tạm dừng — bấm nút Tiếp tục cạnh bên để bật lại',
    'yt.scheduledShares.item.runNowTip': 'Chạy ngay',
    'yt.scheduledShares.item.runNowAria': 'Chạy ngay',
    'yt.scheduledShares.item.editTip': 'Chỉnh sửa bài này',
    'yt.scheduledShares.item.editAria': 'Chỉnh sửa',
    'yt.scheduledShares.item.resumeTip': 'Tiếp tục chạy',
    'yt.scheduledShares.item.pauseTip': 'Tạm dừng bài này',
    'yt.scheduledShares.item.resumeAria': 'Tiếp tục',
    'yt.scheduledShares.item.pauseAria': 'Tạm dừng',
    'yt.scheduledShares.item.cancelTip': 'Huỷ video này',
    'yt.scheduledShares.item.cancelAria': 'Huỷ',
    'yt.scheduledShares.batch.collapse': 'Thu gọn',
    'yt.scheduledShares.batch.expand': 'Mở rộng',
    'yt.scheduledShares.batch.videoCount': '{n} video',
    'yt.scheduledShares.batch.solo': 'Lịch lẻ',
    'yt.scheduledShares.batch.pending': '{n} chờ',
    'yt.scheduledShares.batch.done': '{n} xong',
    'yt.scheduledShares.batch.failed': '{n} lỗi',
    'yt.scheduledShares.batch.canceled': '{n} huỷ',
    'yt.scheduledShares.batch.pageCount': '{n} page',
    'yt.scheduledShares.editModal.title': 'Sửa bài lên lịch',
    'yt.scheduledShares.editModal.video': 'Video',
    'yt.scheduledShares.editModal.noTitle': '(không có tiêu đề)',
    'yt.scheduledShares.editModal.scheduledAt': 'Thời gian đăng',
    'yt.scheduledShares.editModal.futureHint': 'Phải là thời điểm trong tương lai.',
    'yt.scheduledShares.editModal.caption': 'Nội dung caption',
    'yt.scheduledShares.editModal.captionPlaceholder': 'Caption sẽ đăng kèm khi share...',
    'yt.scheduledShares.editModal.close': 'Đóng',
    'yt.scheduledShares.editModal.saveChanges': 'Lưu thay đổi',

    // Videos.js
    'yt.videos.selectedCount': 'Đã chọn {n} video.',
    'yt.videos.loadAllFailed': 'Tải toàn bộ video thất bại.',
    'yt.videos.back': 'Quay lại',
    'yt.videos.channelVideos': 'Video của kênh',
    'yt.videos.upload': 'Đăng video',
    'yt.videos.autoShare': 'Tự động share',
    'yt.videos.scheduled': 'Lịch đã đặt',
    'yt.videos.openOnYoutube': 'Mở kênh trên YouTube',
    'yt.videos.loadFailed': 'Không tải được danh sách video.',
    'yt.videos.loadFailedHint': 'Vui lòng đăng nhập lại YouTube và thử lại.',
    'yt.videos.empty.title': 'Kênh chưa có video',
    'yt.videos.empty.desc': 'Khi bạn upload video, danh sách sẽ hiển thị ở đây.',
    'yt.videos.selectedWithChannel': 'Đã chọn {n} / {total} video kênh',
    'yt.videos.selected': 'Đã chọn {n}',
    'yt.videos.selectPage': 'Chọn {n} video trang này',
    'yt.videos.loadingProgress': 'Đang tải {loaded}/{total}...',
    'yt.videos.loading': 'Đang tải...',
    'yt.videos.selectAllChannel': 'Chọn toàn bộ kênh',
    'yt.videos.selectAllChannelCount': 'Chọn toàn bộ kênh ({n})',
    'yt.videos.unselect': 'Bỏ chọn',
    'yt.videos.scheduleShare': 'Lên lịch share {n} video',
    'yt.videos.shareFbTip': 'Chia sẻ lên Facebook Page',
    'yt.videos.shareXTip': 'Đăng lên X (Twitter)',
    'yt.videos.historyTip': 'Xem lịch sử chia sẻ',
    'yt.videos.total': 'Tổng cộng: {n} video',
    'yt.videos.loadingSuffix': ' (đang tải...)',
    'yt.videos.prevPage': 'Trang trước',
    'yt.videos.nextPage': 'Trang sau',

    // YoutubeAccount.js
    'yt.youtubeAccount.title': 'Tài khoản YouTube',
    'yt.youtubeAccount.guide': 'Hướng dẫn',
    'yt.youtubeAccount.add': 'Thêm',
    'yt.youtubeAccount.searchLabel': 'Tìm kiếm tài khoản',
    'yt.youtubeAccount.searchPlaceholder': 'Nhập tên kênh, email...',
    'yt.youtubeAccount.search': 'Tìm kiếm',
    'yt.youtubeAccount.reset': 'Đặt lại',

    // components/Table.js
    'yt.table.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'yt.table.statusChangeFailed': 'Thay đổi trạng thái tài khoản thất bại',
    'yt.table.deleteConfirmTitle': 'Xoá tài khoản YouTube?',
    'yt.table.deleteConfirmDesc': 'Hành động này không thể hoàn tác.',
    'yt.table.deleteConfirmText': 'Xoá',
    'yt.table.deleteSuccess': 'Xóa tài khoản thành công',
    'yt.table.deleteFailed': 'Xóa tài khoản thất bại',
    'yt.table.copied': 'Đã sao chép {label}.',
    'yt.table.copyDefaultLabel': 'giá trị',
    'yt.table.copyChannelId': 'channel ID',
    'yt.table.colChannel': 'Kênh',
    'yt.table.colEmail': 'Email',
    'yt.table.colChannelId': 'Channel ID',
    'yt.table.colStatus': 'Trạng thái',
    'yt.table.colCreatedAt': 'Ngày tạo',
    'yt.table.colAction': 'Thao tác',
    'yt.table.viewVideos': 'Xem video',
    'yt.table.updateAccount': 'Cập nhật tài khoản',
    'yt.table.refreshScope': 'Cấp lại quyền / làm mới scope',
    'yt.table.deleteAccount': 'Xóa tài khoản',
    'yt.table.emptyTitle': 'Chưa có dữ liệu',
    'yt.table.emptyDesc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',

    // components/VideoShareHistoryModal.js
    'yt.videoShareHistory.linkFacebook': 'Xem post trên Facebook',
    'yt.videoShareHistory.linkX': 'Xem tweet trên X',
    'yt.videoShareHistory.linkDefault': 'Xem post',
    'yt.videoShareHistory.title': 'Lịch sử chia sẻ',
    'yt.videoShareHistory.emptyTitle': 'Chưa chia sẻ lần nào',
    'yt.videoShareHistory.emptyDesc': 'Lịch sử chia sẻ video này sẽ hiển thị ở đây.',
    'yt.videoShareHistory.success': 'Thành công',
    'yt.videoShareHistory.failed': 'Thất bại',
    'yt.videoShareHistory.error': 'Lỗi: {msg}',
    'yt.videoShareHistory.close': 'Đóng',

    // components/YoutubeAccountForm.js
    'yt.youtubeAccountForm.linkedFallback': 'Đã liên kết kênh YouTube',
    'yt.youtubeAccountForm.loginAgain': 'Đăng nhập lại YouTube',
    'yt.youtubeAccountForm.login': 'Đăng nhập YouTube',
    'yt.youtubeAccountForm.update': 'Cập nhật',
    'yt.youtubeAccountForm.create': 'Tạo',
    'yt.youtubeAccountForm.googleDenied': 'Google từ chối đăng nhập: {reason}',
    'yt.youtubeAccountForm.invalidState': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'yt.youtubeAccountForm.fetchInfoFailed': 'Lấy thông tin YouTube thất bại',
    'yt.youtubeAccountForm.missingClientId':
      'Thiếu cấu hình REACT_APP_YOUTUBE_CLIENT_ID (hoặc REACT_APP_GOOGLE_CLIENT_ID).',
    'yt.youtubeAccountForm.updateSuccess': 'Cập nhật tài khoản thành công.',
    'yt.youtubeAccountForm.updateFailed': 'Cập nhật tài khoản thất bại.',
    'yt.youtubeAccountForm.needLogin': 'Bạn cần đăng nhập YouTube trước khi tạo tài khoản.',
    'yt.youtubeAccountForm.createSuccess': 'Tạo tài khoản thành công.',
    'yt.youtubeAccountForm.createFailed': 'Tạo tài khoản thất bại.',
    'yt.youtubeAccountForm.titleUpdate': 'Cập nhật tài khoản YouTube',
    'yt.youtubeAccountForm.titleCreate': 'Tạo tài khoản YouTube',
    'yt.youtubeAccountForm.nameLabel': 'Tên gợi nhớ',
    'yt.youtubeAccountForm.channelTitleLabel': 'Tên kênh',
    'yt.youtubeAccountForm.channelIdLabel': 'Channel ID',
    'yt.youtubeAccountForm.emailLabel': 'Email Google',
    'yt.youtubeAccountForm.activate': 'Kích hoạt',
    'yt.youtubeAccountForm.cancel': 'Hủy',

    // components/YoutubeLoginGuideModal.js
    'yt.youtubeLoginGuide.step1.title': 'Bắt đầu thêm tài khoản',
    'yt.youtubeLoginGuide.step1.desc':
      'Bấm nút "Thêm" ở góc phải trên, sau đó bấm "Đăng nhập YouTube".',
    'yt.youtubeLoginGuide.step2.title': 'Chọn tài khoản YouTube',
    'yt.youtubeLoginGuide.step2.desc':
      'Trong cửa sổ "Đăng nhập bằng Google", chọn tài khoản (hoặc tài khoản thương hiệu / kênh YouTube) mà bạn muốn liên kết.',
    'yt.youtubeLoginGuide.step3.title': 'Bỏ qua cảnh báo "Google chưa xác minh ứng dụng này"',
    'yt.youtubeLoginGuide.step3.badge': 'QUAN TRỌNG',
    'yt.youtubeLoginGuide.step3.descPrefix': 'Khi gặp màn hình cảnh báo, bấm ',
    'yt.youtubeLoginGuide.step3.advanced': '"Nâng cao"',
    'yt.youtubeLoginGuide.step3.descMid': ' ở góc trái dưới, sau đó bấm liên kết ',
    'yt.youtubeLoginGuide.step3.goLink': '"Đi tới social-panel.adda.link (không an toàn)"',
    'yt.youtubeLoginGuide.step3.descSuffix': '.',
    'yt.youtubeLoginGuide.step4.title': 'Cấp quyền cho ứng dụng',
    'yt.youtubeLoginGuide.step4.desc':
      'Bấm "Tiếp tục" qua các bước cấp quyền cho tới khi quay lại trang quản trị Social Panel.',
    'yt.youtubeLoginGuide.step5.title': 'Hoàn tất thêm tài khoản',
    'yt.youtubeLoginGuide.step5.desc':
      'Bấm "Tạo" để lưu tài khoản YouTube vừa liên kết vào hệ thống. Tài khoản sẽ xuất hiện trong bảng danh sách.',
    'yt.youtubeLoginGuide.header': 'Hướng dẫn đăng nhập tài khoản YouTube',
    'yt.youtubeLoginGuide.intro':
      'Làm theo các bước dưới đây để liên kết một tài khoản YouTube mới với hệ thống.',
    'yt.youtubeLoginGuide.warning':
      'Do ứng dụng đang trong quá trình xác minh với Google, bạn sẽ gặp cảnh báo "Google chưa xác minh ứng dụng này". Đây là bước bình thường - hãy bấm "Nâng cao" rồi chọn "Đi tới social-panel.adda.link (không an toàn)" để tiếp tục.',
    'yt.youtubeLoginGuide.success':
      'Sau khi hoàn tất, tài khoản YouTube sẽ tự động hiển thị trong bảng danh sách.',
    'yt.youtubeLoginGuide.gotIt': 'Đã hiểu',

    // components/FacebookPostPreview.js
    'yt.facebookPostPreview.noContent': '(chưa có nội dung)',
    'yt.facebookPostPreview.noThumbnail': 'No thumbnail',
    'yt.facebookPostPreview.videoTitleFallback': 'Tên video',
    'yt.facebookPostPreview.like': 'Thích',
    'yt.facebookPostPreview.comment': 'Bình luận',
    'yt.facebookPostPreview.share': 'Chia sẻ',

    // components/XPostPreview.js
    'yt.xPostPreview.noContent': '(chưa có nội dung)',
    'yt.xPostPreview.accountFallback': 'Tài khoản X',
    'yt.xPostPreview.now': 'bây giờ',
    'yt.xPostPreview.noThumbnail': 'No thumbnail',
    'yt.xPostPreview.videoTitleFallback': 'Tên video',
  },
  en: {
    // ScheduledShares.js — status filters
    'yt.scheduledShares.status.all': 'All',
    'yt.scheduledShares.status.pending': 'Pending',
    'yt.scheduledShares.status.processing': 'Processing',
    'yt.scheduledShares.status.done': 'Done',
    'yt.scheduledShares.status.failed': 'Failed',
    'yt.scheduledShares.status.canceled': 'Canceled',
    // ScheduledShares.js — relative time
    'yt.scheduledShares.rel.soon': 'soon',
    'yt.scheduledShares.rel.justNow': 'just now',
    'yt.scheduledShares.rel.inMinutes': 'in {n} min',
    'yt.scheduledShares.rel.minutesAgo': '{n} min ago',
    'yt.scheduledShares.rel.inHours': 'in {n}h',
    'yt.scheduledShares.rel.hoursAgo': '{n}h ago',
    'yt.scheduledShares.rel.inDays': 'in {n}d',
    'yt.scheduledShares.rel.daysAgo': '{n}d ago',
    // ScheduledShares.js — edit batch drawer
    'yt.scheduledShares.drawer.shiftLater': 'later',
    'yt.scheduledShares.drawer.shiftEarlier': 'earlier',
    'yt.scheduledShares.drawer.amountMinutes': '{n} min',
    'yt.scheduledShares.drawer.amountHours': '{n}h',
    'yt.scheduledShares.drawer.shiftSummary': '→ Shift {amount} {direction}',
    'yt.scheduledShares.drawer.noChange': 'No changes.',
    'yt.scheduledShares.drawer.captionOverLimit': 'Caption exceeds the character limit.',
    'yt.scheduledShares.drawer.selectAtLeastOnePage': 'Select at least 1 page.',
    'yt.scheduledShares.drawer.startMustBeFuture': 'New start time must be in the future.',
    'yt.scheduledShares.drawer.pagesGone':
      'The selected pages are no longer in the account. Please reselect.',
    'yt.scheduledShares.drawer.title': 'Edit batch schedule — all pending of the channel',
    'yt.scheduledShares.drawer.pendingWillUpdate':
      '{n} pending posts will be updated (across all batches)',
    'yt.scheduledShares.drawer.pendingNote':
      'Posted / processing / canceled posts stay unchanged — not affected. Only the fields you actually change are sent.',
    'yt.scheduledShares.drawer.sectionPages': 'Target pages',
    'yt.scheduledShares.drawer.changed': 'Changed',
    'yt.scheduledShares.drawer.reload': 'Reload',
    'yt.scheduledShares.drawer.searchPagePlaceholder': 'Search by page name...',
    'yt.scheduledShares.drawer.loadPagesFailed': 'Could not load pages.',
    'yt.scheduledShares.drawer.noPages': 'This Facebook account manages no pages.',
    'yt.scheduledShares.drawer.noPageMatch': 'No page matches "{q}".',
    'yt.scheduledShares.drawer.unselect': 'Unselect',
    'yt.scheduledShares.drawer.selectVisible': 'Select {n} shown pages',
    'yt.scheduledShares.drawer.selectAll': 'Select all {n} pages',
    'yt.scheduledShares.drawer.sectionCaption': 'Caption template',
    'yt.scheduledShares.drawer.tokenLabel': 'Tokens',
    'yt.scheduledShares.drawer.tokenSuffix': 'render per video',
    'yt.scheduledShares.drawer.charCount': '{n} / {max} chars',
    'yt.scheduledShares.drawer.sectionStart': 'Start time',
    'yt.scheduledShares.drawer.startHintPrefix': 'Change the time of the ',
    'yt.scheduledShares.drawer.startHintBold': 'first',
    'yt.scheduledShares.drawer.startHintSuffix':
      ' post — all remaining posts shift by the same delta, keeping the spacing between videos.',
    'yt.scheduledShares.drawer.pickNewStart': 'Pick new start date & time',
    'yt.scheduledShares.drawer.currentFirst': 'Current first post: {time}',
    'yt.scheduledShares.drawer.currentLast': ' → last post: {time}',
    'yt.scheduledShares.drawer.willChange': 'Will change:',
    'yt.scheduledShares.drawer.badgePages': 'Pages',
    'yt.scheduledShares.drawer.badgeCaption': 'Caption',
    'yt.scheduledShares.drawer.badgeTime': 'Time',
    'yt.scheduledShares.drawer.noChangesYet': 'No changes yet.',
    'yt.scheduledShares.drawer.cancel': 'Cancel',
    'yt.scheduledShares.drawer.save': 'Save',
    'yt.scheduledShares.drawer.saveWithCount': 'Save ({n} posts)',
    // ScheduledShares.js — main view
    'yt.scheduledShares.channelUntitled': 'Untitled channel',
    'yt.scheduledShares.allChannels': 'All channels',
    'yt.scheduledShares.editItem.invalidTime': 'Please pick a valid time.',
    'yt.scheduledShares.editItem.mustBeFuture': 'Time must be in the future.',
    'yt.scheduledShares.editItem.updated': 'Scheduled post updated.',
    'yt.scheduledShares.editItem.updateFailed': 'Update failed.',
    'yt.scheduledShares.item.resumed': 'Resumed this post.',
    'yt.scheduledShares.item.paused': 'Paused this post.',
    'yt.scheduledShares.item.resumeFailed': 'Resume failed.',
    'yt.scheduledShares.item.pauseFailed': 'Pause failed.',
    'yt.scheduledShares.editAll.selectChannelFirst':
      'Please select a YouTube channel before editing.',
    'yt.scheduledShares.editAll.fieldPages': 'pages',
    'yt.scheduledShares.editAll.fieldCaption': 'caption',
    'yt.scheduledShares.editAll.fieldTime': 'time',
    'yt.scheduledShares.editAll.updatedSkipped':
      'Updated {fields} for {updated} posts. Skipped {skipped}.',
    'yt.scheduledShares.editAll.updated': 'Updated {fields} for {updated} posts.',
    'yt.scheduledShares.editAll.updateFailed': 'Update failed.',
    'yt.scheduledShares.pause.selectChannelFirst':
      'Please select a YouTube channel before pausing.',
    'yt.scheduledShares.pause.noActive': 'No active posts left to pause.',
    'yt.scheduledShares.pause.confirmTitle': 'Pause the channel schedule?',
    'yt.scheduledShares.pause.confirmDesc':
      'All {n} pending posts will be paused — cron won\'t auto-post until you click "Resume". Posted / processing posts are not affected.',
    'yt.scheduledShares.pause.confirmText': 'Pause',
    'yt.scheduledShares.pause.success': 'Paused {n} posts.',
    'yt.scheduledShares.pause.failed': 'Pause failed.',
    'yt.scheduledShares.resume.selectChannelFirst':
      'Please select a YouTube channel before resuming.',
    'yt.scheduledShares.resume.noPaused': 'No posts are paused.',
    'yt.scheduledShares.resume.success':
      'Resumed {n} posts. Overdue posts will run on the next cron tick.',
    'yt.scheduledShares.resume.failed': 'Resume failed.',
    'yt.scheduledShares.cancelAll.selectChannelFirst':
      'Please select a YouTube channel before canceling.',
    'yt.scheduledShares.cancelAll.noPending': 'This channel has no pending posts to cancel.',
    'yt.scheduledShares.cancelAll.confirmTitle': 'Cancel {n} pending posts?',
    'yt.scheduledShares.cancelAll.confirmDesc':
      'All {n} pending posts of the channel will switch to "Canceled" and won\'t auto-post anymore. Posted / processing posts stay unchanged. This action cannot be undone.',
    'yt.scheduledShares.cancelAll.confirmText': 'Cancel all',
    'yt.scheduledShares.cancelAll.success': 'Canceled {n} pending posts.',
    'yt.scheduledShares.cancelAll.failed': 'Cancel failed.',
    'yt.scheduledShares.cancel.confirmTitle': 'Cancel share schedule?',
    'yt.scheduledShares.cancel.confirmDesc': 'The post "{title}" will not be shared.',
    'yt.scheduledShares.cancel.confirmText': 'Cancel schedule',
    'yt.scheduledShares.cancel.success': 'Schedule canceled.',
    'yt.scheduledShares.cancel.failed': 'Cancel failed.',
    'yt.scheduledShares.runNow.confirmTitle': 'Run now?',
    'yt.scheduledShares.runNow.confirmDesc': 'The post will be shared within a few seconds.',
    'yt.scheduledShares.runNow.confirmText': 'Run now',
    'yt.scheduledShares.runNow.triggered': 'Triggered. Status updates in a few seconds.',
    'yt.scheduledShares.runNow.failed': 'Trigger failed.',
    'yt.scheduledShares.back': 'Back',
    'yt.scheduledShares.heading': 'YouTube share schedule',
    'yt.scheduledShares.subtitle': 'Manage posts scheduled to auto-share to Facebook Pages',
    'yt.scheduledShares.editAllTip.selectChannel':
      'Select a YouTube channel to bulk-edit the schedule',
    'yt.scheduledShares.editAllTip.noPending': 'This channel has no pending posts to edit',
    'yt.scheduledShares.editAllTip.has':
      'Edit pages / caption / time for {n} pending posts of this channel',
    'yt.scheduledShares.editAllBtn': 'Edit schedule',
    'yt.scheduledShares.cancelAllTip.selectChannel': 'Select a YouTube channel to cancel pending',
    'yt.scheduledShares.cancelAllTip.noPending': 'This channel has no pending posts',
    'yt.scheduledShares.cancelAllTip.has': 'Cancel all {n} pending posts of this channel',
    'yt.scheduledShares.cancelAllBtn': 'Cancel all',
    'yt.scheduledShares.pauseTip.selectChannel': 'Select a YouTube channel first',
    'yt.scheduledShares.pauseTip.resume': 'Resume {n} paused posts',
    'yt.scheduledShares.pauseTip.noActive': 'No active posts left to pause',
    'yt.scheduledShares.pauseTip.pause':
      'Pause {n} pending posts — cron will skip them until you resume',
    'yt.scheduledShares.resumeBtn': 'Resume',
    'yt.scheduledShares.pauseBtn': 'Pause schedule',
    'yt.scheduledShares.reload': 'Reload',
    'yt.scheduledShares.toChannels': 'Go to YouTube channels',
    'yt.scheduledShares.channelLabel': 'Channel:',
    'yt.scheduledShares.empty.statusTitle': 'No schedule in status "{status}"',
    'yt.scheduledShares.empty.title': 'No share schedules yet',
    'yt.scheduledShares.empty.descPrefix':
      "Create a schedule to auto-share YouTube videos to Facebook Pages at your chosen time. Open a channel's video list → tick multiple videos → click ",
    'yt.scheduledShares.empty.descBold': 'Schedule share',
    'yt.scheduledShares.empty.descSuffix': '.',
    'yt.scheduledShares.empty.cta': 'Go to channel list',
    'yt.scheduledShares.item.noTitle': '(no title)',
    'yt.scheduledShares.item.pausedBadge': 'Paused',
    'yt.scheduledShares.item.pageCount': '{n} page(s)',
    'yt.scheduledShares.item.runNowDisabledTip':
      'Paused — click the Resume button next to it to re-enable',
    'yt.scheduledShares.item.runNowTip': 'Run now',
    'yt.scheduledShares.item.runNowAria': 'Run now',
    'yt.scheduledShares.item.editTip': 'Edit this post',
    'yt.scheduledShares.item.editAria': 'Edit',
    'yt.scheduledShares.item.resumeTip': 'Resume',
    'yt.scheduledShares.item.pauseTip': 'Pause this post',
    'yt.scheduledShares.item.resumeAria': 'Resume',
    'yt.scheduledShares.item.pauseAria': 'Pause',
    'yt.scheduledShares.item.cancelTip': 'Cancel this video',
    'yt.scheduledShares.item.cancelAria': 'Cancel',
    'yt.scheduledShares.batch.collapse': 'Collapse',
    'yt.scheduledShares.batch.expand': 'Expand',
    'yt.scheduledShares.batch.videoCount': '{n} videos',
    'yt.scheduledShares.batch.solo': 'Single schedule',
    'yt.scheduledShares.batch.pending': '{n} pending',
    'yt.scheduledShares.batch.done': '{n} done',
    'yt.scheduledShares.batch.failed': '{n} failed',
    'yt.scheduledShares.batch.canceled': '{n} canceled',
    'yt.scheduledShares.batch.pageCount': '{n} page(s)',
    'yt.scheduledShares.editModal.title': 'Edit scheduled post',
    'yt.scheduledShares.editModal.video': 'Video',
    'yt.scheduledShares.editModal.noTitle': '(no title)',
    'yt.scheduledShares.editModal.scheduledAt': 'Post time',
    'yt.scheduledShares.editModal.futureHint': 'Must be a time in the future.',
    'yt.scheduledShares.editModal.caption': 'Caption',
    'yt.scheduledShares.editModal.captionPlaceholder': 'Caption to post when sharing...',
    'yt.scheduledShares.editModal.close': 'Close',
    'yt.scheduledShares.editModal.saveChanges': 'Save changes',

    // Videos.js
    'yt.videos.selectedCount': 'Selected {n} videos.',
    'yt.videos.loadAllFailed': 'Failed to load all videos.',
    'yt.videos.back': 'Back',
    'yt.videos.channelVideos': 'Channel videos',
    'yt.videos.upload': 'Upload video',
    'yt.videos.autoShare': 'Auto share',
    'yt.videos.scheduled': 'Schedules',
    'yt.videos.openOnYoutube': 'Open channel on YouTube',
    'yt.videos.loadFailed': 'Could not load the video list.',
    'yt.videos.loadFailedHint': 'Please sign in to YouTube again and retry.',
    'yt.videos.empty.title': 'No videos yet',
    'yt.videos.empty.desc': 'When you upload videos, the list will appear here.',
    'yt.videos.selectedWithChannel': 'Selected {n} / {total} channel videos',
    'yt.videos.selected': 'Selected {n}',
    'yt.videos.selectPage': 'Select {n} videos on this page',
    'yt.videos.loadingProgress': 'Loading {loaded}/{total}...',
    'yt.videos.loading': 'Loading...',
    'yt.videos.selectAllChannel': 'Select entire channel',
    'yt.videos.selectAllChannelCount': 'Select entire channel ({n})',
    'yt.videos.unselect': 'Unselect',
    'yt.videos.scheduleShare': 'Schedule share for {n} videos',
    'yt.videos.shareFbTip': 'Share to Facebook Page',
    'yt.videos.shareXTip': 'Post to X (Twitter)',
    'yt.videos.historyTip': 'View share history',
    'yt.videos.total': 'Total: {n} videos',
    'yt.videos.loadingSuffix': ' (loading...)',
    'yt.videos.prevPage': 'Previous',
    'yt.videos.nextPage': 'Next',

    // YoutubeAccount.js
    'yt.youtubeAccount.title': 'YouTube accounts',
    'yt.youtubeAccount.guide': 'Guide',
    'yt.youtubeAccount.add': 'Add',
    'yt.youtubeAccount.searchLabel': 'Search accounts',
    'yt.youtubeAccount.searchPlaceholder': 'Enter channel name, email...',
    'yt.youtubeAccount.search': 'Search',
    'yt.youtubeAccount.reset': 'Reset',

    // components/Table.js
    'yt.table.statusChanged': 'Account status changed',
    'yt.table.statusChangeFailed': 'Failed to change account status',
    'yt.table.deleteConfirmTitle': 'Delete YouTube account?',
    'yt.table.deleteConfirmDesc': 'This action cannot be undone.',
    'yt.table.deleteConfirmText': 'Delete',
    'yt.table.deleteSuccess': 'Account deleted successfully',
    'yt.table.deleteFailed': 'Failed to delete account',
    'yt.table.copied': 'Copied {label}.',
    'yt.table.copyDefaultLabel': 'value',
    'yt.table.copyChannelId': 'channel ID',
    'yt.table.colChannel': 'Channel',
    'yt.table.colEmail': 'Email',
    'yt.table.colChannelId': 'Channel ID',
    'yt.table.colStatus': 'Status',
    'yt.table.colCreatedAt': 'Created at',
    'yt.table.colAction': 'Actions',
    'yt.table.viewVideos': 'View videos',
    'yt.table.updateAccount': 'Update account',
    'yt.table.refreshScope': 'Re-authorize / refresh scope',
    'yt.table.deleteAccount': 'Delete account',
    'yt.table.emptyTitle': 'No data yet',
    'yt.table.emptyDesc': 'Add the first record to get started',

    // components/VideoShareHistoryModal.js
    'yt.videoShareHistory.linkFacebook': 'View post on Facebook',
    'yt.videoShareHistory.linkX': 'View tweet on X',
    'yt.videoShareHistory.linkDefault': 'View post',
    'yt.videoShareHistory.title': 'Share history',
    'yt.videoShareHistory.emptyTitle': 'Never shared',
    'yt.videoShareHistory.emptyDesc': 'The share history of this video will appear here.',
    'yt.videoShareHistory.success': 'Success',
    'yt.videoShareHistory.failed': 'Failed',
    'yt.videoShareHistory.error': 'Error: {msg}',
    'yt.videoShareHistory.close': 'Close',

    // components/YoutubeAccountForm.js
    'yt.youtubeAccountForm.linkedFallback': 'YouTube channel linked',
    'yt.youtubeAccountForm.loginAgain': 'Sign in to YouTube again',
    'yt.youtubeAccountForm.login': 'Sign in to YouTube',
    'yt.youtubeAccountForm.update': 'Update',
    'yt.youtubeAccountForm.create': 'Create',
    'yt.youtubeAccountForm.googleDenied': 'Google denied sign-in: {reason}',
    'yt.youtubeAccountForm.invalidState': 'Invalid OAuth state, please sign in again.',
    'yt.youtubeAccountForm.fetchInfoFailed': 'Failed to fetch YouTube info',
    'yt.youtubeAccountForm.missingClientId':
      'Missing REACT_APP_YOUTUBE_CLIENT_ID (or REACT_APP_GOOGLE_CLIENT_ID) config.',
    'yt.youtubeAccountForm.updateSuccess': 'Account updated successfully.',
    'yt.youtubeAccountForm.updateFailed': 'Failed to update account.',
    'yt.youtubeAccountForm.needLogin': 'You must sign in to YouTube before creating an account.',
    'yt.youtubeAccountForm.createSuccess': 'Account created successfully.',
    'yt.youtubeAccountForm.createFailed': 'Failed to create account.',
    'yt.youtubeAccountForm.titleUpdate': 'Update YouTube account',
    'yt.youtubeAccountForm.titleCreate': 'Create YouTube account',
    'yt.youtubeAccountForm.nameLabel': 'Nickname',
    'yt.youtubeAccountForm.channelTitleLabel': 'Channel name',
    'yt.youtubeAccountForm.channelIdLabel': 'Channel ID',
    'yt.youtubeAccountForm.emailLabel': 'Google email',
    'yt.youtubeAccountForm.activate': 'Activate',
    'yt.youtubeAccountForm.cancel': 'Cancel',

    // components/YoutubeLoginGuideModal.js
    'yt.youtubeLoginGuide.step1.title': 'Start adding an account',
    'yt.youtubeLoginGuide.step1.desc':
      'Click the "Add" button at the top right, then click "Sign in to YouTube".',
    'yt.youtubeLoginGuide.step2.title': 'Choose a YouTube account',
    'yt.youtubeLoginGuide.step2.desc':
      'In the "Sign in with Google" window, choose the account (or brand account / YouTube channel) you want to link.',
    'yt.youtubeLoginGuide.step3.title': 'Bypass the "Google hasn\'t verified this app" warning',
    'yt.youtubeLoginGuide.step3.badge': 'IMPORTANT',
    'yt.youtubeLoginGuide.step3.descPrefix': 'When you see the warning screen, click ',
    'yt.youtubeLoginGuide.step3.advanced': '"Advanced"',
    'yt.youtubeLoginGuide.step3.descMid': ' at the bottom left, then click the link ',
    'yt.youtubeLoginGuide.step3.goLink': '"Go to social-panel.adda.link (unsafe)"',
    'yt.youtubeLoginGuide.step3.descSuffix': '.',
    'yt.youtubeLoginGuide.step4.title': 'Grant permissions to the app',
    'yt.youtubeLoginGuide.step4.desc':
      'Click "Continue" through the permission steps until you return to the Social Panel admin page.',
    'yt.youtubeLoginGuide.step5.title': 'Finish adding the account',
    'yt.youtubeLoginGuide.step5.desc':
      'Click "Create" to save the just-linked YouTube account to the system. The account will appear in the list table.',
    'yt.youtubeLoginGuide.header': 'YouTube account sign-in guide',
    'yt.youtubeLoginGuide.intro':
      'Follow the steps below to link a new YouTube account with the system.',
    'yt.youtubeLoginGuide.warning':
      'Because the app is being verified with Google, you\'ll see a "Google hasn\'t verified this app" warning. This is normal — click "Advanced" then choose "Go to social-panel.adda.link (unsafe)" to continue.',
    'yt.youtubeLoginGuide.success':
      'Once done, the YouTube account will automatically appear in the list table.',
    'yt.youtubeLoginGuide.gotIt': 'Got it',

    // components/FacebookPostPreview.js
    'yt.facebookPostPreview.noContent': '(no content yet)',
    'yt.facebookPostPreview.noThumbnail': 'No thumbnail',
    'yt.facebookPostPreview.videoTitleFallback': 'Video title',
    'yt.facebookPostPreview.like': 'Like',
    'yt.facebookPostPreview.comment': 'Comment',
    'yt.facebookPostPreview.share': 'Share',

    // components/XPostPreview.js
    'yt.xPostPreview.noContent': '(no content yet)',
    'yt.xPostPreview.accountFallback': 'X account',
    'yt.xPostPreview.now': 'now',
    'yt.xPostPreview.noThumbnail': 'No thumbnail',
    'yt.xPostPreview.videoTitleFallback': 'Video title',
  },
};

export default fragment;
